import { render, staticRenderFns } from "./signFlowRecordList.vue?vue&type=template&id=b1d471c8&scoped=true&"
import script from "./signFlowRecordList.vue?vue&type=script&lang=js&"
export * from "./signFlowRecordList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1d471c8",
  null
  
)

export default component.exports